module.exports = __webpack_public_path__ + "img/skip-start.a62a8e80.svg";